import { useCreateShopMutation } from '../store/shops-api';
import { handleShopCreateError } from '../utils/helpers/shops-errors';
import { useShowResponseStatus } from '@/shared';

import type { TShopCreateParams } from '../store/types';

export const useCreateShop = () => {
  const [createShop, { isLoading, isSuccess, error }] = useCreateShopMutation();
  const createError = handleShopCreateError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Магазин успешно создан',
    error: createError,
  });

  const handleCreateShop = async (params: TShopCreateParams) => {
    await createShop(params);
  };

  return {
    handleCreateShop,
    createShop,
    isLoading,
  };
};
